(function () {
  var STORAGE_KEY = 'scarcity_units';

  function getUnits() {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) return parseInt(stored, 10);
    var units = 3 + Math.floor(Math.random() * 7);
    sessionStorage.setItem(STORAGE_KEY, units);
    return units;
  }

  function init() {
    var picker = document.querySelector('.bundle-picker');
    if (!picker) return;

    var units = getUnits();
    var el = document.createElement('div');
    el.className = 'scarcity-indicator';
    el.innerHTML =
      '<span class="scarcity-indicator__dot"></span>' +
      '⚠️ Solo quedan <span class="scarcity-indicator__count">' + units + ' unidades</span> al precio especial';

    picker.parentNode.insertBefore(el, picker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
